import React from "react";

import Table from "../../common/Table";
import RowPhoto from "../../common/TdImg";
import Option from "../../common/RowOption";

import { Link } from "react-router-dom";

const ContractorsList = ({ data, query }) => {
  const columns = [
    { path: "id", label: "شماره" },
    {
      path: "photo",
      label: "عکس",
      content: ({ photo }) => <RowPhoto src={photo} />,
    },
    {
      path: "name",
      label: "نام (فارسی)",
      content: (e) => (
        <Link
          to={`/mis/contractor/${e.id}/profile/finance?contractorName=${e.name}`}
        >
          {e.name}
        </Link>
      ),
    },
    { path: "name_en", label: "نام (انگلیسی)" },
    { path: "phone", label: "شماره تماس" },
    { path: "email", label: "ایمیل" },

    { path: "remark", label: "ملاحظه" },
    {
      path: "option",
      content: (e) => (
        <Option
          Edit={{ form: "contractor-form", cache: e.id, edit: e }}
          Delete={{ route: "contractors", id: e.id }}
        />
      ),
    },
  ];

  return <Table data={data} columns={columns} query={query} />;
};

export default ContractorsList;
